<template>
  <div class="home">
    <b-container fluid>
      <h1>Dashboard</h1>

      <b-tabs>
        <b-tab title="Vacancy Dashboard">
          <!--  <h1 class="text-center text-danger my-2"><strong>Vacancy Dashboard is currently under construction and will be unavailable until further notice. We thank you for your patience.</strong></h1>-->
          <b-row>
            <b-col>
              <strong>* Week Key Metrics since {{ keyMetrics.metricsSinceDate }}</strong>
              <div>
                <b-table striped hover :items="keyMetrics.metrics"                
                         :fields="keyMetricsFields">
                         <template #table-caption></template>
                </b-table>
              </div>
            </b-col>
            <b-col>
              <strong>Open Vacancies - Agency Total</strong>
              <pie-chart
                  v-if="loaded"
                  :chartdata="chartdata"
                  :styles="myStyles"
                  :options="options"
                  id="pie-chart-vacancies"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong>Open Vacancies By Division</strong>
              <!--
                    <b-tabs content-class="mt-3">
                      <b-tab title="visual" active>
              -->
              <division-count
                  v-if="loadedDivisionCount"
                  :chartdata="divisionCountChartData"
                  :styles="myStyles"
                  :options="barOptions"
                  id="bar-chart-division"
              />
              <!--        </b-tab>
                      <b-tab title="data" v-if="false">
                        <b-table hover small responsive show-empty
                                 style="font-size:.80em;"
                                 :fields="divisionCountChartFields"
                                 :items="divisionSummaryCount"
                                 :busy="loadedDivisionCount">
                          <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">Reset</v-btn>
                          </template>

                          <template v-slot:empty="scope">
                            <p>No data found</p>
                          </template>

                          <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                            <strong>Loading, Please Wait...</strong>
                          </div>
                        </b-table>
                      </b-tab>
                    </b-tabs>-->
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <OpenByDivision request-type='Vacancy'/>
            </b-col>
          </b-row>


        </b-tab>

        <b-tab title="Leave Dashboard">
          <b-row>
            <b-col>
              <strong>Key Leave Metrics</strong>
              <div>
                <b-table striped hover :items="leaveKeyMetrics.leaveMetrics"
                         :fields="leaveKeyMetricsFields">
                         <template #table-caption></template>
                </b-table>
              </div>
            </b-col>
            <b-col v-show="false">
              <strong>Total Leave Requests</strong>
              <pie-chart
                  v-if="leaveLoaded"
                  :chartdata="leaveChartdata"
                  :styles="myStyles"
                  :options="options"
                  id="pie-chart-leave"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong>Open Leaves By Division</strong>
              <b-tabs content-class="mt-3">
                <b-tab title="visual" active>
                  <division-count
                      v-if="loadedDivisionLeaveCount"
                      :chartdata="divisionLeaveCountChartData"
                      :styles="myStyles"
                      :options="barOptions"
                      id="bar-chart-leave"
                  />
                </b-tab>
                <b-tab title="data" v-if="false">
                  <b-table hover small responsive show-empty
                           style="font-size:.80em;"
                           :fields="divisionCountChartFields"
                           :items="divisionSummaryLeaveCount"
                           :busy="loadedDivisionLeaveCount">
                    <template #table-caption></template>
                    <template v-slot:no-data>
                      <v-btn color="primary" @click="initialize">Reset</v-btn>
                    </template>

                    <template v-slot:empty="scope">
                      <p>No data found</p>
                    </template>

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                      <strong>Loading, Please Wait...</strong>
                    </div>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <OpenByDivision request-type='Leave'/>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

    </b-container>
  </div>
</template>

<script>
import PieChart from '@/components/charting/Chart.vue'
import DivisionCount from '@/components/charting/DivisionCount.vue'
import OpenByDivision from '@/components/reports/OpenByDivision.vue'
import pageTitle from '@/mixins/pageTitle'
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';

// import a particular color scheme
import {Tableau20} from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau';
import axios from "axios"
import HiringStageSummary from "@/components/reports/HiringStageSummary";
import CompletedVacancySummary from "@/components/reports/CompletedVacancySummary";

export default {
  title: 'Dashboard',
  name: 'LineChartContainer',
  components: {
    PieChart, DivisionCount,
    OpenByDivision
  },
  data: () => ({
    loaded: false,
    leaveLoaded: false,
    loadedDivisionCount: false,
    loadedDivisionLeaveCount: false,
    chartdata: {},
    leaveChartdata: {},
    divisionCountChartData: {},
    divisionLeaveCountChartData: {},
    divisionCountChartFields: [
      {key: 'division', sortable: true, label: 'division'},
      {key: 'count', sortable: true, label: 'count'},
    ],
    keyMetrics: {},
    keyMetricsFields: [
      {key: 'label', label: 'Metric Name'},
      {key: 'value', label: 'Week *'},
      {key: 'yearToDate', label: 'Fiscal Year'}
    ],


    leaveKeyMetrics: {},
    leaveKeyMetricsFields: [
      {key: 'label', label: "Metric Name"},
      {key: 'fmla', label: "FMLA"},
      {key: 'other', label: "Other"},
      {key: 'total', label: "Total"},
    ],

    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom'
      },
      plugins: {
        colorschemes: {
          scheme: Tableau20
        }
      }
    },
    barOptions: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom'
      },
      plugins: {
        colorschemes: {
          scheme: Tableau20
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            stepSize: 1,
          }
        }],
      }
    }
  }),
  mixins: [
    pageTitle
  ],
  mounted() {
    this.loaded = false
    this.loadedDivisionCount = false

    // countsByStatus/01_02_03_04_05_06_07_08_09_10_11_12_13_14_15_16_17
    axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/countsByStatusCategories`)
        .then(response => {
          this.chartdata = response.data
          console.log("Count by status")
          console.log(response.data)
          this.loaded = true
        })
    axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/leaveCountsByTypeCategories`)
        .then(response => {
          this.leaveChartdata = response.data
          console.log("Leave Chart Data")
          console.log(response.data)
          this.leaveLoaded = true
        })

    axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/leaveCountsByDivision`)
        .then(response => {
          this.divisionLeaveCountChartData = response.data
          this.loadedDivisionLeaveCount = true
          console.log("Leave Count by division")
          console.log(response.data)
        })

    axios.get(`${process.env.VUE_APP_API_BASE_URL}/report/countsByDivision`)
        .then(response => {
          this.divisionCountChartData = response.data
          this.loadedDivisionCount = true
          console.log("Count by division")
          console.log(response.data)

        })

    axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/keyMetrics`)
        .then(response => {
          this.keyMetrics = response.data
          console.log("Key Metrics")
          console.log(response.data)

          this.loadedKeyMetrics = true
        })

    axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/keyLeaveMetrics`)
        .then(response => {
          this.leaveKeyMetrics = response.data
          console.log("Key Leave Metrics")
          console.log(response.data)

          this.loadedKeyMetrics = true
        })

  },
  computed: {
    myStyles() {
      return {
        height: '300px',
        position: 'relative'
      }
    },
    divisionSummaryCount() {
      var divisionSummary = []
      if (typeof this.divisionCountChartData.labels !== 'undefined') {
        for (let idx = 0; idx < this.divisionCountChartData.labels.length; idx++) {
          divisionSummary.push({
            division: this.divisionCountChartData.labels[idx],
            count: this.divisionCountChartData.datasets[0].data[idx]
          })
        }
      }
      return divisionSummary
    },
    divisionSummaryLeaveCount() {
      var divisionSummary = []
      if (typeof this.divisionLeaveCountChartData.labels !== 'undefined') {
        for (let idx = 0; idx < this.divisionLeaveCountChartData.labels.length; idx++) {
          divisionSummary.push({
            division: this.divisionLeaveCountChartData.labels[idx],
            count: this.divisionLeaveCountChartData.datasets[0].data[idx]
          })
        }
      }
      return divisionSummary
    }
  }
}
</script>

<style>

</style>